export const BUILDER_RUN_PARAM = 'run';

export const BUILDER_PANE_DETAILS = 'details';
export const BUILDER_PANE_APP = 'app';
export const BUILDER_PANE_CHAT = 'chat';

export type BuilderPane = typeof BUILDER_PANE_DETAILS | typeof BUILDER_PANE_APP | typeof BUILDER_PANE_CHAT;

export const THUMBNAIL_DIRECTION_MAX_CHARS = 300;

export const BUDDY_HOME_PREVIEW = 'preview';
export const BUDDY_HOME_THUMBNAIL = 'thumbnail';

export const BUILDING_ORB_PX = 260;
export const BUILDING_ORB_SMALL_PX = 200;
/** Narrower than this, the building buddy talks below the orb rather than beside it. */
export const BUILDING_SIDE_TIPS_MIN_PX = 700;
export const THUMBNAIL_BUDDY_PX = 150;
export const COACH_BUDDIES_PX = 88;
export const COACH_SHOWN_MS = 12000;
/** How long the building screen takes to fade off the finished app. */
export const BUILD_REVEAL_MS = 450;
/** How long a side column takes to fold away; the coach waits for it. */
export const COLUMN_FOLD_MS = 350;
export const FILLING_BUDDIES_PX = 120;
/** The Details sketch draws itself again this often while the first build fills them in. */
export const FILLING_REDRAW_MS = 6000;
